import { Button } from "@mui/material"
import { Component, ErrorInfo, ReactNode } from "react"
import { Card, Col, Row } from "react-bootstrap"
import { withRouter } from "react-router-dom"
import { RoutePaths } from "../../../../routes/RoutePaths"

interface Props {
  children: ReactNode
  history: any
}

interface State {
  hasError: boolean
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(_: Error): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error("Error occurred in ErrorBoundary:", error, errorInfo)
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  }

  handleClick = () => {
    const { history } = this.props
    history.push({
      pathname: RoutePaths.DASHBOARD
    })
    history.go(0)
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <Row className="justify-content-center m-t-20">
          <Col md="auto">
            <Card>
              <Card.Body>
                <span style={{ fontSize: "30px" }}>
                  Something went wrong, You will be redirected to the login page.
                </span>
                {/* <div className="d-flex justify-content-center align-items-center">
                  <Button variant="contained" onClick={this.handleClick}>
                    Home
                  </Button>
                </div> */}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )
    }

    return this.props.children
  }
}

export default withRouter(ErrorBoundary)
